export const initialState = {
    processCompare: {
        layer1_filters: {
            variants: [],
            active_variants: [],
            filters: [],
            flow: [],
            metrics: [],
            advanced_activity_filters:[]
        },
        layer2_filters: {
            variants: [],
            active_variants: [],
            filters: [],
            flow: [],
            metrics: [],
            advanced_activity_filters:[]
        }
    },
    itemActiveIndex:'',
    dataPoolIdInProgress: '',
    dataPoolCards: [],
    processMapFilters: [],
    processMapAdvancedActivityFilters1: [],
    processMapAdvancedActivityFilters2: [],
    processMapVariants: [1],
    processMapMetrics: [],
    processMapAdvancedActivityFilters: [],
    processExplorerFilters: [],
    processExplorerActiveFilters: [],
    processExplorerFlow: [],
    processExplorerVariants: [],
    processExplorerActiveVariants: [],
    processExplorerView: 'caseCount',
    processExplorerMetrics: [],
    processExplorerAdvancedActivityFilters: [],
    processCompareVariants: false,
    processCompareFilters: [],
    processCompareMetrics: [],
    activeVariantsProcessMap: [1],
    generateBpmnFilters: [],
    generateBpmnVariants: [1],
    generateBpmnActiveVariants: [1],
    generateBpmnFlow: [],
    generateBpmnMetrics: [],
    dataAnalysisFilters: [],
    dataAnalysisVariants: [],
    dataAnalysisActiveVariants: [],
    dataAnalysisFlow: [],
    dataAnalysisMetrics: [],
    dataAnalysisAdvancedActivityFilters: [],
    conformanceCheckingVariants: [],
    conformanceCheckingActiveVariants: [],
    conformanceCheckingActiveFilters: [],
    conformanceCheckingActiveFlow: [],
    conformanceCheckingMetrics: [],
    conformanceCheckingAdvancedActivityFilters: [],
    conformanceCheckingActiveSaveObj: {
        variants: [1],
        activeVariants: [1],
        filters: [],
        flow: []
    },
    activeVariantsProcessCompare: [1],
    activeFiltersProcessCompare: [],
    activeFiltersProcessMap: [],
    bpmnId: null,
    processCompareSaveVersion: 0
}